"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataList = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _react = _interopRequireDefault(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _dataListModule = _interopRequireDefault(require("./data-list.module.scss"));
var DataList = function DataList(_ref) {
  var children = _ref.children,
    withoutLines = _ref.withoutLines;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames2.default)(_dataListModule.default['data-list'], (0, _defineProperty2.default)({}, _dataListModule.default['data-list--without-lines'], withoutLines))
  }, children);
};
exports.DataList = DataList;